import React, { useState, useEffect } from "react";
import TableCell from "@mui/material/TableCell";

const FileUploaderCell = ({ row, col, onFileChange }) => {
  const [selectedFile, setSelectedFile] = useState(null);
  const [previewUrl, setPreviewUrl] = useState(null);
  const [isEditing, setIsEditing] = useState(false);

  useEffect(() => {
    console.log("row:", row);
    console.log("col.accessor:", col.accessor);
    const existingFile = row?.[col?.accessor];
    console.log("existingFile:", existingFile);
    if (existingFile) {
      setPreviewUrl(existingFile);
    } else {
      setPreviewUrl(null);
    }
    setSelectedFile(null);
    setIsEditing(false);
  }, [row, col]);

  const handleChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    console.log("Selected file:", file);

    setSelectedFile(file);
    const fileUrl = URL.createObjectURL(file);
    console.log("Created object URL:", fileUrl);
    setPreviewUrl(fileUrl);

    if (onFileChange) {
      onFileChange(file, row.id, col);
    }

    setIsEditing(false);
  };

  const handleDoubleClick = () => {
    setIsEditing(true);
  };

  const fileName = previewUrl ? previewUrl.split("/").pop() : "";
  const isImage = /\.(jpeg|jpg|gif|png|bmp|webp)$/i.test(fileName);

  console.log("Preview URL:", previewUrl);

  return (
    <TableCell
      key={col.accessor}
      onDoubleClick={handleDoubleClick}
      style={{ cursor: "pointer", padding: "8px" }}
    >
      <div style={{ textAlign: "left", paddingLeft: "10px" }}>
        {isEditing ? (
          <input
            type="file"
            accept="image/*"
            onChange={handleChange}
            onClick={(e) => e.stopPropagation()}
            autoFocus
          />
        ) : previewUrl ? (
          isImage ? (
            <img
              src={previewUrl}
              alt="Uploaded File"
              style={{
                maxWidth: "100px",
                maxHeight: "100px",
                objectFit: "cover",
                borderRadius: "8px",
                cursor: "pointer",
              }}
              onError={(e) => {
                e.target.onerror = null;
                e.target.src = "";
                console.warn("Image failed to load.");
              }}
            />
          ) : (
            <p>File preview not supported</p>
          )
        ) : (
          <p style={{ color: "#999", fontStyle: "italic" }}>No photo</p>
        )}

        {selectedFile && (
          <p style={{ fontSize: "13px", color: "#555" }}>
            Selected file: <strong>{selectedFile.name}</strong>
          </p>
        )}
      </div>
    </TableCell>
  );
};

export default FileUploaderCell;
